import * as React from 'react';
import { SimpleDataStore, UniversalMemoryStorage, memoryStorage, useMemoryData } from '../storage/index.js';
import { isServer } from '../utils/index.js';
import { DataContainer, IsomorphicDataContext } from './isomorphic-data-context.js';
const localStore = useMemoryData('crystal-isomorphic-local', () => new SimpleDataStore());
const globalStore = UniversalMemoryStorage.getOrCreate('crystal-isomorphic-global');
const serverOnlyTypes = ['prerender', 'isolated'];
export const IsomorphicDataContainer = ({ prefetchId, children, }) => {
    if (!isServer()) {
        return React.createElement(React.Fragment, null, children);
    }
    if (!memoryStorage.isUsingAsyncStorage() && !prefetchId) {
        throw new Error(`'containerId' must be provided when not running with AsyncLocalStorage.`);
    }
    const context = getContainer(prefetchId);
    const fetchData = context?.cache ? [...context.cache] : [];
    const scripts = fetchData
        .filter(([, data]) => !serverOnlyTypes.includes(data.type))
        .map(([key, data]) => (React.createElement("script", { ...new DataContainer(key).attrs(), dangerouslySetInnerHTML: { __html: JSON.stringify(data) } })));
    return (React.createElement(IsomorphicDataContext.Provider, { value: context },
        children,
        scripts));
};
export function initializeContainer() {
    localStore().set({
        fetchers: [],
        cache: new Map(),
        pending: new Map(),
    });
}
export function getContainer(containerId) {
    let container;
    if (memoryStorage.isUsingAsyncStorage()) {
        container = localStore().get();
    }
    else if (containerId) {
        container = globalStore.get(containerId);
    }
    if (!container) {
        throw new Error(`Isomorphic Data not found. ContainerId: '${containerId}'`);
    }
    return container;
}
export function transferContainer(containerId) {
    globalStore.set(containerId, getContainer());
}
//# sourceMappingURL=isomorphic-data-container.js.map